import React, { Component } from 'react';
import Page from '../../components/Page/Page';
import SideImage from '../../components/SideImage/SideImage';
import ProductGrid from '../../components/ProductGrid/ProductGrid';
import ProductGridRow from '../../components/ProductGridRow/ProductGridRow';
import data from '../../data/accessories.js';
import { Link } from 'react-router-dom';
import NextPage from '../../components/NextPage/NextPage';

class PageAccessories extends Component {

  render() {
    return (
        <Page primaryTitle="Accessories" secondaryTitle="" section="">
            <div className="col-sm-8 col-sm-push-4 col-lg-9 col-lg-push-3 pageDisplays">
                <p className="intro">SLA offers everything you need to enhance and complete the look of your exhibit. Take a look at what we have to offer. If you don't see what you are looking for here, <Link to="/contact">contact us</Link> and we will get it for you!</p>

                <ProductGrid caption="Accessories">
                    <ProductGridRow data={data.cases}>
                        <h4>Shipping Cases for Displays &amp; Graphics</h4>
                        <p>You've purchased the display, now you need to store it and protect it during shipment to your events. SLA offers a line of display and accessory cases that will keep your display safe while in the house or on the road!</p>
                    </ProductGridRow>
                    <ProductGridRow data={data.crates}>
                        <h4>Custom Shipping Crates</h4>
                        <p>For larger/custom exhibits or items which need extra protection during transit, SLA can build customized shipping crates to cradle your exhibit during transit and keep everything secured and organized in the house.</p>
                        <p><Link to="/contact">Contact Us</Link> to discuss your needs</p>
                    </ProductGridRow>
                    <ProductGridRow data={data.tablethrows}>
                        <h4>Tablethrows</h4>
                        <p>A customized tablethrow is the perfect compliment to your display. Add your company logo or message to complete the look of your exhibit. Tablethrows come in a variety of styles and in 6 ft. and 8 ft. sizes. Message application ranges from simple one-color Perma Logo to Full Transfer dye sublimation processes that are perfect for throws featuring photographic images, color gradations, or complex images over the entire throw.</p>
                    </ProductGridRow>
                    <ProductGridRow data={data.outdoor_event}>
                        <h4>Outdoor &amp; Event Products</h4>
                        <p>Event tents? Flag stands? Inflatable displays? Outdoor banner systems? SLA has what you need to attract attention at any indoor and outdoor event.</p>
                    </ProductGridRow>
                    <ProductGridRow data={data.counters}>
                        <h4>Counters / TV Stands</h4>
                        <p>Perhaps you are looking for a portable workstation or counter that would be ideal for customer greetings or as a ticket booth or sampling station. SLA has exactly what you need in a portable but sturdy solution.</p>
                    </ProductGridRow>

                </ProductGrid>

                <NextPage page={this.props.page}/>

            </div>
            <aside className="col-sm-4 col-sm-pull-8 col-lg-3 col-lg-pull-9 sidebar">
                <SideImage page={this.props.page} />
            </aside>
        </Page>
    );
  }
}

export default PageAccessories;



// WEBPACK FOOTER //
// ./src/pages/PageAccessories/PageAccessories.js